import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.board_id',
  })

  let current_user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'user.id',
  })

  return {
    variables: {
      id,
      current_user_id,
    },
    pause: !id || id === 'new',
  }
}
